import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgAirplaneCrossed = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <defs>
        <mask id="airplaneCrossed_svg__a">
          <rect width="100%" height="100%" fill="#fff" />
          <rect width={20} height={20} x={32} y={32} rx={10} />
        </mask>
      </defs>
      <path
        fill="#96979A"
        d="m39.458 27.845 4.553-4.284.026-.027a5 5 0 0 0-7.071-7.072c0 .01-.018.018-.027.027l-4.284 4.553-12.97-4.719a1.25 1.25 0 0 0-1.31.291l-3.75 3.75a1.25 1.25 0 0 0 .19 1.923l9.983 6.655-2.315 2.308H19.25a1.25 1.25 0 0 0-.883.366l-3.75 3.75a1.25 1.25 0 0 0 .414 2.043l5.753 2.302 2.297 5.742.01.025a1.25 1.25 0 0 0 2.059.386l3.73-3.731a1.25 1.25 0 0 0 .37-.883v-3.233l2.306-2.306 6.655 9.983a1.25 1.25 0 0 0 1.923.19l3.75-3.75a1.25 1.25 0 0 0 .291-1.31zm-.011 15.192-6.655-9.98a1.25 1.25 0 0 0-.917-.557h-.123a1.25 1.25 0 0 0-.885.367l-3.75 3.75a1.25 1.25 0 0 0-.367.883v3.233l-2.042 2.042-1.797-4.494a1.25 1.25 0 0 0-.692-.692l-4.49-1.797 2.04-2.042H23a1.25 1.25 0 0 0 .884-.366l3.75-3.75a1.25 1.25 0 0 0-.19-1.925l-9.982-6.656 2.11-2.108 13.003 4.728a1.25 1.25 0 0 0 1.337-.312l4.835-5.142a2.5 2.5 0 0 1 3.534 3.536l-5.136 4.832a1.25 1.25 0 0 0-.312 1.338l4.728 13.003-2.114 2.11Z"
        mask="url(#airplaneCrossed_svg__a)"
      />
      <path
        stroke="#DE370C"
        strokeLinecap="round"
        strokeWidth={2}
        d="m46 38-8 8m8 0-8-8"
      />
    </svg>
  );
};
export default SvgAirplaneCrossed;
